import { render } from "./playlist.vue?vue&type=template&id=5f3dc854&scoped=true"
import script from "./playlist.vue?vue&type=script&lang=js"
export * from "./playlist.vue?vue&type=script&lang=js"

import "./playlist.vue?vue&type=style&index=0&id=5f3dc854&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3dc854"]])

export default __exports__